import { CalendarDate } from '@internationalized/date';
import { useDateFormatter } from '@react-aria/i18n';

import range from '../../../../helpers/array/range';
import PredefinedDatesCalendar, {
    DateValue,
} from '../PredefinedDatesCalendar/PredefinedDatesCalendar';

type YearCalendarProps = {
    focusedDate: CalendarDate;
    value?: CalendarDate | null;
    onChange: (focusDate: CalendarDate) => void;
    timeZone: string;
    numYears: number;

    minValue?: CalendarDate;
    maxValue?: CalendarDate;
};

const YearCalendar = ({
    focusedDate,
    value,
    timeZone,
    onChange,
    numYears = 12,
    minValue,
    maxValue,
}: YearCalendarProps) => {
    const formatter = useDateFormatter({
        year: 'numeric',
        timeZone: timeZone,
    });

    const start = focusedDate.year - Math.floor(numYears / 3);
    const end = start + numYears;

    const dates: Array<DateValue> = range(start, end - 1).map((year) => {
        const date = focusedDate.set({ year });

        return {
            label: formatter.format(date.toDate(timeZone)),
            value: date,
            disabled:
                (minValue && date.compare(minValue) < 0) ||
                (maxValue && date.compare(maxValue) > 0),
        };
    });

    return (
        <PredefinedDatesCalendar
            dates={dates}
            value={value}
            onChange={onChange}
        />
    );
};

export default YearCalendar;
